import { render, staticRenderFns } from "./VanFieldTab.vue?vue&type=template&id=6b72a11e&scoped=true&"
import script from "./VanFieldTab.vue?vue&type=script&lang=js&"
export * from "./VanFieldTab.vue?vue&type=script&lang=js&"
import style0 from "./VanFieldTab.vue?vue&type=style&index=0&id=6b72a11e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b72a11e",
  null
  
)

export default component.exports